import { __generator } from "tslib";
import { takeLatest, call, all, put, select } from 'redux-saga/effects';
import { request } from '../../xhr';
import snakeCase from 'lodash/snakeCase';
import { dropFirstTimeFlag, unsetFirstTimeFlag } from './actions';
import { hasFirstTimeFlag } from './selectors';
function dropFlagHandler(_a) {
    var isFlagSet, result;
    var _b = _a.payload, flag = _b.flag, redirectTo = _b.redirectTo;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(hasFirstTimeFlag, flag)];
            case 1:
                isFlagSet = _c.sent();
                if (!isFlagSet) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(unsetFirstTimeFlag(flag))];
            case 2:
                _c.sent();
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/drop_first_time_flag',
                        data: { flag: snakeCase(flag) },
                    }, function () { return ({
                        success: true,
                    }); })];
            case 3:
                result = _c.sent();
                if (result && result.success && redirectTo) {
                    window.location.href = redirectTo;
                }
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([takeLatest(dropFirstTimeFlag, dropFlagHandler)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map